import { DpCouponAccount } from '@/components/blocks/DpLibrary/DpCouponAccount';
import { DpMemberPromotionRender } from '@/components/blocks/DpMemberPromotionRender';
import { useDppLandingHref } from '@/data/Content/DppMemberPromotion';
import type { DppMemberPromotion } from '@/data/dpp/types';
import { useUser } from '@/data/User';
import {
	buildDppLandingHref,
	getDppFirstName,
	getDppRedeemableTimeLeft,
} from '@/utils/dppPromotion';
import { SxProps, Theme } from '@mui/material';

const accountCouponSX: SxProps<Theme> = { mb: 3 };

const AccountCouponContent = ({ promotion }: { promotion: DppMemberPromotion }) => {
	const { user } = useUser();
	const landing = useDppLandingHref();
	const firstName = getDppFirstName(user?.firstName);
	const expiration = getDppRedeemableTimeLeft(promotion, Date.now(), true);

	if (!expiration) {
		return null;
	}

	return (
		<DpCouponAccount
			name={firstName}
			discount={`${promotion.discountPercent}%`}
			expiration={expiration}
			href={landing ? buildDppLandingHref(landing, promotion, firstName) : undefined}
			sx={accountCouponSX}
		/>
	);
};

/** Cupón DPP en el resumen de Mi cuenta, debajo de las opciones de la cuenta. */
export const DppAccountCoupon = () => (
	<DpMemberPromotionRender
		renderData={(promotion) => <AccountCouponContent promotion={promotion} />}
	/>
);
